import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

import { chartSeriesColors, colors } from "Infrastructure/Themes/Colors";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useReportingGenerationsQuery } from "Reporting/Api/Queries/useReportingGenerationsQuery";
import { ChartCard } from "./ChartCard";
import { ChartEmptyState } from "./ChartEmptyState";

const CHART_COLORS = chartSeriesColors;
const c = colors();

const renderLabel = (props: { percent?: number }): string =>
  `${((props.percent ?? 0) * 100).toFixed(0)}%`;

export const VoiceModelUsageChart = (): React.ReactNode => {
  const { t } = useResource();
  const { data, isLoading } = useReportingGenerationsQuery();

  const chartData = (data?.voiceModelUsageThisMonth ?? []).map((item) => ({
    ...item,
    label: t(Resources.Common.VoiceLlms[item.voiceLlm]),
  }));
  const isEmpty = chartData.length === 0;

  return (
    <ChartCard
      title={t(Resources.Reporting.VoiceModelUsageThisMonth)}
      isLoading={isLoading}
      height={350}
    >
      {isEmpty ? (
        <ChartEmptyState />
      ) : (
        <ResponsiveContainer width="100%" height={350}>
          <PieChart>
            <Pie
              data={chartData}
              dataKey="count"
              nameKey="label"
              cx="50%"
              cy="45%"
              outerRadius={100}
              label={renderLabel}
              labelLine={{ stroke: "rgba(255, 255, 255, 0.3)" }}
              strokeWidth={0}
            >
              {chartData.map((entry, index) => (
                <Cell
                  key={entry.voiceLlm}
                  fill={CHART_COLORS[index % CHART_COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip
              contentStyle={{
                backgroundColor: c.BackgroundTile,
                border: `1px solid ${c.Border}`,
                borderRadius: 8,
              }}
              labelStyle={{ color: c.TextSecondary }}
              itemStyle={{ color: c.White }}
            />
            <Legend
              wrapperStyle={{
                color: "rgba(255, 255, 255, 0.7)",
                fontSize: 12,
              }}
            />
          </PieChart>
        </ResponsiveContainer>
      )}
    </ChartCard>
  );
};
